import SatDim from '@components/common/satUI/SatDim';
import React, { useEffect, useState } from 'react';

const HomeMainAccessChecker = () => {
  const { isTabletMode } = $hooks.useEnv();
  const { logout } = $hooks.useUser();
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [zIndex, setZIndex] = useState(250);

  const handleLogout = () => {
    // 태블릿일 경우, 알림 노출 후 로그아웃
    if (isTabletMode) logout(false);
    setIsShowAlert(true);
  };

  useEffect(() => {
    setZIndex($utils.getModalZIndex());
  }, [isShowAlert]);

  return isShowAlert ? (
    <>
      <div
        className="modal layer-info"
        style={{ display: 'block', zIndex: zIndex + 10 }}
      >
        <div className="cont">
          <p className="layer-text text-center">
            <span>
              KB LAS 접근 권한이 부여되지 않았습니다.
              <br />
            </span>
            <span>
              담당자를 통하여 권한을 부여 받고 접속바랍니다.
              <br />
            </span>
          </p>
        </div>

        <div className="layer-footer">
          <button className="btn-s blue btn-wide" onClick={handleLogout}>
            <span>{isTabletMode ? '로그아웃' : '확인'}</span>
          </button>
        </div>
      </div>

      <SatDim isShow zIndex={zIndex} />
    </>
  ) : (
    <></>
  );
};

export default HomeMainAccessChecker;
